package com.tedd.db

import kotlin.Long
import kotlin.String

public data class Note_revision(
  public val id: String,
  public val note_id: String,
  public val title: String?,
  public val body: String,
  public val created_at: Long,
  public val kept_at: Long,
)
